export default __webpack_public_path__ + "static/media/digital_tr_green.1d2afb55.png";